<div class="card">
  <div class="card-header card-chart card-header-primary">
    <h5 class="card-title text-center"><b>Modificar usuario</b></h5>
  </div>
  <div class="card-body">
    <div class="container">
      <form [formGroup]="formData">
        <div class="row">
          <!--Nombre-->
          <div class="col-sm-6">
            <mat-form-field class="example-full-width">
              <input formControlName="nombre" [ngModel]="" matInput aria-label="Nombre" type="text" placeholder="Nombre">
            </mat-form-field>
          </div>
          <!--Apellido Paterno-->
          <div class="col-sm-6">
            <mat-form-field class="example-full-width">
              <input formControlName="apellidoP" [ngModel]="" matInput aria-label="Apellido Paterno" type="text" placeholder="Apellido Paterno">
            </mat-form-field>
          </div>
       </div>
        <div class="row">
          <!--Apellido Materno-->
          <div class="col-sm-6">
            <mat-form-field class="example-full-width">
              <input formControlName="apellidoM" [ngModel]="" matInput aria-label="Apellido Materno" type="text" placeholder="Apellido Materno">
            </mat-form-field>
          </div>
          <!--Email-->
          <div class="col-sm-6">
            <mat-form-field class="example-full-width">
              <input formControlName="email" [ngModel]="" matInput aria-label="Email" type="text" placeholder="Email">
            </mat-form-field>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6 cent">
              <button [disabled]="formData.invalid" mat-raised-button class="btn btn-info btn-sm float-right">
                <span><i class="material-icons">save</i></span>
                &nbsp; Guardar
              </button>
            </div>
            <div class="col-sm-6 cent">
              <button mat-raised-button class="btn btn-info btn-sm" (click)="onNoClick()">
                <span><i class="material-icons">cancel</i></span>
                &nbsp; Cancelar
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
